import CardNetworks from "../../../../content/sdk/web/2.x.x/_common/cardNetworks.mdx";
import Locale from "../../../../content/sdk/web/2.x.x/_common/locale.mdx";
import * as React from 'react';
export default {
  CardNetworks,
  Locale,
  React
};